import type { ChromeCopy } from '../types/chrome';

export const chromeEs: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - Menús con código QR para restaurantes | safestmenu.com',
    defaultDescription:
      'Crea con SafestMenu en safestmenu.com un menú digital multilingüe con código QR. Tus clientes escanean; tú actualizas precios. Empieza gratis.',
  },
  header: {
    homeAriaLabel: 'Inicio de SafestMenu',
    mainNavAriaLabel: 'Principal',
    mobileNavAriaLabel: 'Móvil',
    nav: {
      why: 'Por qué SafestMenu',
      howItWorks: 'Cómo funciona',
      aboutUs: 'Sobre nosotros',
    },
    ctaLabel: 'Abrir la aplicación',
    openMenuAriaLabel: 'Abrir menú',
    closeMenuAriaLabel: 'Cerrar menú',
  },
  footer: {
    tagline:
      'El menú con código QR para restaurantes, cafeterías y bares. Fácil de configurar, seguro para tus clientes y respetuoso con la naturaleza.',
    siteNavAriaLabel: 'Sitio',
    legalNavAriaLabel: 'Legal',
    exploreHeading: 'Explora',
    companyHeading: 'Empresa',
    nav: {
      why: 'Por qué SafestMenu',
      howItWorks: 'Cómo funciona',
      allergenGuide: 'Guía de alérgenos de la UE',
      blog: 'Blog',
      openApp: 'Abrir la aplicación',
      aboutUs: 'Sobre nosotros',
      impressum: 'Aviso legal',
      terms: 'Términos y condiciones',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Creado por',
    copyrightSuffix: 'SafestMenu. Todos los derechos reservados.',
  },
  consent: {
    message:
      'Usamos cookies para analítica y para medir el rendimiento publicitario. Puedes aceptar o rechazar - el sitio funciona igual en ambos casos. No las usamos para personalizar anuncios.',
    decline: 'Rechazar',
    accept: 'Aceptar',
    settings: 'Configuración de cookies',
  },
  languageSwitcher: {
    label: 'Cambiar idioma',
  },
  localeSuggestion: {
    message: 'Esta página también está disponible en español.',
    accept: 'Ver en español',
    dismiss: 'No, gracias',
  },
  emailCapture: {
    defaultTitle: 'Recibe consejos sobre menús en tu correo',
    defaultDescription:
      'Notas ocasionales y prácticas sobre menús, alérgenos y cómo llevar un restaurante sin papel. Sin spam.',
    defaultPlaceholder: 'tu@restaurante.com',
    defaultButtonLabel: 'Suscribirme',
    emailLabel: 'Correo electrónico',
    loadingButtonLabel: 'Suscribiendo…',
    successMessage:
      'Ya estás en la lista. Vigila tu bandeja de entrada para recibir consejos sobre menús.',
    errorMessage: 'Algo salió mal. Inténtalo de nuevo en un momento.',
  },
  qrPlate: {
    linkAriaLabel: 'Escanea o toca para abrir el menú de demostración en vivo de SafestMenu',
    svgAriaLabelPrefix: 'Código QR que enlaza a ',
    caption: 'Escanea o haz clic - es real',
  },
  notFound: {
    seoTitle: 'Página no encontrada',
    heading: 'Este plato no está en el menú.',
    message: 'La página que buscas no existe o se ha movido.',
    backLabel: 'Volver al menú',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Notas prácticas sobre menús QR, la experiencia de tus clientes y cómo llevar un restaurante sin papel.',
    eyebrow: 'Blog',
    heading: 'Notas sobre menús, clientes y cómo llevar un restaurante sin papel.',
    emptyMessage: 'Muy pronto, nuevas publicaciones.',
  },
};
